import { createFileRoute } from '@tanstack/react-router';

import {
  AuctionBiddersPage,
  registrationListQueryOptions,
  registrationListSearchSchema,
  registrationSearchParams,
} from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/bidders')({
  staticData: { crumb: 'auctions:nav.bidders' },
  validateSearch: registrationListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...registrationListQueryOptions(params.storeId, registrationSearchParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    if (cause !== 'stay') await prefetch;
  },
  component: AuctionBiddersPage,
});
